module.exports = __webpack_public_path__ + "images/wv-favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/wv-favicon.ico
// module id = Fwp0
// module chunks = 154